export default __webpack_public_path__ + "f7bff4a5afad07379cbf506fc7507aab.woff";